/* eslint-disable */
import { GetterTree } from "vuex";
import { Post } from "@/models/post";
import { Pagination } from "@/models/pagination";
import { RootState } from "@/types";
import { PostState } from "@/types/post";

const getters: GetterTree<PostState, RootState> = {
  list: (state) => {
    return state.pagination ? state.pagination.data : [];
  },
  pagination: (state) => {
    return state.pagination || new Pagination();
  },
  single: (state) => {
    return state.single || new Post();
  },
  // selectItem: (state) => {
  //   return state.pagination
  //     ? state.pagination.data.map((post) => Post.toSelectItem(post))
  //     : [];
  // },
  find: (state) => (id: number) => {
    return state.pagination
      ? state.pagination.data.find((post) => {
          return post.id == id;
        })
      : new Post();
  },
};

export default getters;
